<!----
    Author: hjlee
    Description:
        추가 필드 컨트롤
---->
<template>
  <div class="additional-field-sample-control">
    <div class="additional-field-info-title">
      {{ $t('common.title.additional_field_info') }}
    </div>
    <div class="additional-field-sample-control-title">
      <div v-for="(additionalFieldInfo, index) in infoData.additionalFieldInfos" :key="index" class="additional-field">
        <div v-if="additionalFieldInfo.hasFields" class="meta-type">
          {{ $t(getDefaultColumnNameCode(additionalFieldInfo.fieldName.toSnakeCase())) }}
        </div>
        <div v-for="(datum, datumIndex) in orderedFieldInfoData(additionalFieldInfo)" :key="datumIndex" class="additional-field-info-area">
          <div v-if="isVisible(datum, additionalFieldInfo)">
            <div v-if="datum.adit_field_title" class="meta-selected-item">
              {{ datum.adit_field_title }}
            </div>
            <div class="input-area">
              <div v-if="getValueType(datum.valueTyCode) === 'title'" class="adit-title">
                {{ $t(additionalFieldInfo.ownerModel.toSnakeCase() + '_adit_field_info.nm.' + datum.id) }}
                <hr>
              </div>
              <input-control
                v-else
                v-model="inputVal.additionalFieldData[additionalFieldInfo.ownerModel][datum.id]"
                :name="'sample.adit_field_info.nm.' + datum.id"
                :required="datum.essntlFlag === 'Y'"
                :options="getOptions(datum)"
                :title="$t(additionalFieldInfo.ownerModel.toSnakeCase() + '_adit_field_info.nm.' + datum.id)"
                :type="getValueType(datum.valueTyCode)"
                :file-info="getFileInfo(datum)"
                :table-name="tableName"
                :readonly="readonly"
                :disabled="disabled"
                :visible-data="value"
                @change="onForceUpdate"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    display: {
      type: Boolean,
      required: false
    },
    infoData: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tableName: {
      type: String,
      default: ''
    }
  },
  data: function() {
    return {
      inputVal: undefined
    }
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.inputVal = newVal
        }
      },
      deep: true
    },
    inputVal: {
      handler(newVal, oldVal) {
        this.invalidateTitles()
        this.$emit('input', newVal)
        this.$emit('change', newVal)
        this.$emit('forceUpdate')
      },
      deep: true
    },
    infoData: {
      handler() {
        this.invalidateTitles()
      },
      deep: true
    },
    'infoData.additionalFieldInfos': {
      handler() {
        this.invalidateTitles()
      },
      deep: true
    },
    deep: true
  },
  mounted() {
    this.inputVal = this.value
    this.invalidateTitles()
  },
  methods: {
    orderedFieldInfoData(additionalFieldInfo) {
      const data = window.copyObject(additionalFieldInfo.data)
      let ownerData = window.copyObject(
        this.value[additionalFieldInfo.fieldName]
      )
      if (!ownerData) {
        return []
      }
      if (ownerData.data) {
        ownerData = ownerData.data
      }
      for (let j = 0; j < ownerData.length; j++) {
        if (ownerData[j].data) {
          ownerData[j] = ownerData[j].data
        }
        ownerData[j].adit_field_group_ordr = j + 1
      }
      for (let i = 0; i < data.length; i++) {
        let additionalFieldInfoOrder = 0
        for (let j = 0; j < ownerData.length; j++) {
          const ownerDatum = ownerData[j]
          if (data[i].objectId === ownerDatum.id) {
            additionalFieldInfoOrder = ownerDatum.adit_field_group_ordr
          }
        }

        data[i].compositeOrder =
          (additionalFieldInfoOrder + '').padStart(4, '0') +
          '_' +
          (data[i].ordr + '').padStart(4, '0')
      }
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < data.length; j++) {
          if (data[i].compositeOrder < data[j].compositeOrder) {
            const temp = data[i]
            data[i] = data[j]
            data[j] = temp
          }
        }
      }
      return data
    },
    invalidateTitles() {
      let previousTitle = ''
      for (let i = 0; i < this.infoData.additionalFieldInfos.length; i++) {
        const additionalFieldInfo = this.infoData.additionalFieldInfos[i]
        this.orderedFieldInfoData(additionalFieldInfo)
        additionalFieldInfo.hasFields = false
        for (let j = 0; j < additionalFieldInfo.data.length; j++) {
          const datum = additionalFieldInfo.data[j]
          if (!this.getNameCode(datum, additionalFieldInfo)) {
            continue
          }
          if (
            previousTitle !==
            this.$t(this.getNameCode(datum, additionalFieldInfo))
          ) {
            datum.adit_field_title = this.$t(
              this.getNameCode(datum, additionalFieldInfo)
            )
            previousTitle = this.$t(
              this.getNameCode(datum, additionalFieldInfo)
            )
          }
          if (this.isVisible(datum, additionalFieldInfo)) {
            additionalFieldInfo.hasFields = true
          }
          for (const key in this.value) {
            if (key === additionalFieldInfo.fieldName) {
              let datum
              for (let k = 0; k < this.value[key].length; k++) {
                datum = this.value[key][k]
                additionalFieldInfo.ordr = datum.ordr
              }
            }
          }
        }
      }
      this.$forceUpdate()
    },
    getNameCode(datum, additionalFieldInfo) {
      let code = ''
      code = additionalFieldInfo.ownerModel.toSnakeCase()
      code += '.nm.'
      const ownerData = additionalFieldInfo.ownerData
      if (ownerData.length === 0) {
        return null
      }
      let foundId = false
      for (let i = 0; i < ownerData.length; i++) {
        if (!datum.objectId) {
          return null
        }

        if (datum.objectId !== ownerData[i].id) {
          continue
        }
        foundId = true
        if (ownerData[i].site) {
          code += ownerData[i].site.id + '.'
        }
        code += datum.objectId
        break
      }
      if (!foundId) {
        return null
      }
      return code
    },
    isVisible(datum, additionalFieldInfo) {
      if (!this.inputVal) {
        return false
      }
      if (additionalFieldInfo.visibleType === 'always') {
        return true
      }
      if (additionalFieldInfo.visibleType === 'none') {
        return false
      }
      let visible = false
      let val = this.inputVal
      const ownerData = additionalFieldInfo.ownerData
      const visibleBys = additionalFieldInfo.visibleBy
      for (let i = 0; i < ownerData.length; i++) {
        if (datum.objectId !== ownerData[i].id) {
          continue
        }
        if (additionalFieldInfo.visibleType === 'simple') {
          let allMatched = true
          for (let j = 0; j < visibleBys.length; j++) {
            val = this.inputVal
            const fieldNames = visibleBys[j].fieldName.split('.')
            val = val[fieldNames[0]]
            if (
              !this.isSimpleMatched(
                val,
                visibleBys[j].fieldName,
                ownerData[i],
                visibleBys[j].fieldNameInOwnerModel
              )
            ) {
              allMatched = false
            }
          }
          if (allMatched) {
            visible = true
            break
          }
        }
      }
      return visible
    },
    isSimpleMatched(value, fieldName, ownerData, fieldNameInOwnerData) {
      if (!value) {
        return false
      }

      if (Array.isArray(value) && value && value.length > 0) {
        const fieldNameInOwnerDataKeys = fieldNameInOwnerData.split('.')
        const fieldNameKeys = fieldName.split('.')
        for (let i = 0; i < value.length; i++) {
          let comp1 = value[i]
          let comp2 = ownerData

          if (!this.display) {
            comp1 = comp1.data
          }

          // 이미 첫 필드 이름은 사용한 후이므로 1부터 시작
          for (let i = 1; i < fieldNameKeys.length; i++) {
            comp1 = comp1[fieldNameKeys[i]]
            if (comp1 === undefined || comp1 === null) {
              return false
            }
          }
          for (let i = 0; i < fieldNameInOwnerDataKeys.length; i++) {
            comp2 = comp2[fieldNameInOwnerDataKeys[i]]
            if (comp2 === undefined || comp2 === null) {
              return false
            }
          }

          if (
            comp1 !== undefined &&
            comp2 !== undefined &&
            comp1 !== null &&
            comp2 !== null &&
            comp1 === comp2
          ) {
            return true
          }
        }
        return false
      }
      if (typeof value === 'object') {
        return value[fieldName] === ownerData[fieldNameInOwnerData]
      }
      return value === ownerData[fieldNameInOwnerData]
    },
    getValueType(code) {
      if (code.startsWith('value_type.')) {
        return code.replace('value_type.', '')
      }
      return code
    },
    getFileInfo(datum) {
      if (
        this.getValueType(datum.valueTyCode) === 'singlefile' ||
        this.getValueType(datum.valueTyCode) === 'multifile'
      ) {
        return datum.optn.fileInfo
      }
      return undefined
    },
    getOptions(datum) {
      if (
        !datum ||
        !datum.optn ||
        !datum.optn.options ||
        datum.optn.options.length === 0
      ) {
        return null
      }

      const options = []
      for (let i = 0; i < datum.optn.options.length; i++) {
        const option = datum.optn.options[i]
        if (datum.optn.multilanguage) {
          options.push({
            value: option.value,
            text: this.$t(option.text[0].code)
          })
        } else {
          options.push({
            value: option.value,
            text: option.text
          })
        }
      }

      return options
    }
  }
}
</script>

<style scoped>
.adit-title {
  margin-top: 30px;
  font-weight: bold;
  font-size: 1.1rem;
  color: #555555;
}
.additional-field-sample-control {
  border: 1px solid #aaaaaa;
  padding: 15px;
  border-radius: 10px;
  margin: 15px;
  width: calc(100% - 30px);
}
.additional-field-info-area {
  padding-left: 20px;
}
.meta-selected-item {
  display: block;
}
.additional-field-info-area:first-child .meta-selected-item {
  display: block;
}

.additional-field-info-title {
  font-size: 1.3rem;
  font-weight: bold;
}
.additional-field:first-child .meta-type {
  margin-top: 20px;
}
.meta-type {
  margin-top: 60px;
  font-size: 1.2rem;
  font-weight: bold;
  border-bottom: 1px solid #dddddd;
}
.input-area {
  padding-left: 20px;
}
>>> .adit-title {
  font-size: 1.1rem;
  margin-top: 0px;
}
.meta-selected-item {
  font-size: 1rem;
  border-bottom: 1px solid #dddddd;
  margin-top: 30px;
  margin-bottom: 10px;
}
</style>
